import { SvgIcon } from "@mui/material"

import { ReactComponent as ViewCone } from "./Viseur.svg"

export const ViewConeIcon = (props) => {

    return (
        <SvgIcon
            component={ViewCone}
            inheritViewBox
            {...props}
        />
    )
}
